/**
 * Standalone entry point for the federation build.
 *
 * Renders DevTestView for local development testing.
 * DevTestView provides a hardcoded catalog of test agents for complete
 * UI testing without requiring a backend catalog API.
 *
 * Usage:
 *   - Main UI: /api/flows-alpha-agent/ui/
 *   - Component Demo: /api/flows-alpha-agent/ui/?view=demo
 *   - Agent Builder: /api/flows-alpha-agent/ui/?view=builder
 *
 * When agent-executor runs with DEV_MODE=true
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import DevTestView from './DevTestView';
import AgentBuilderDevView from './AgentBuilderDevView';
import { ComponentDemoPage } from '@/components/assistant-ui/ComponentDemoPage';

// Import styles
import '@/styles/globals.css';

// Get URL params for routing
const urlParams = new URLSearchParams(window.location.search);
const view = urlParams.get('view');
const initialAgentId = urlParams.get('agentId') || undefined;

function App() {
  if (view === 'demo') {
    return <ComponentDemoPage />;
  }
  if (view === 'builder') {
    return <AgentBuilderDevView initialAgentId={initialAgentId} />;
  }
  return <DevTestView initialAgentId={initialAgentId} />;
}

const root = document.getElementById('root');
if (root) {
  ReactDOM.createRoot(root).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
